export const DEFAULT_DESCRIPTION = 'Your vehicle';
